import React, { FunctionComponent } from 'react';
import EmbeddedVideo from '../../Article/EmbeddedVideo';

export type ArticleVideoProps = {
  node?: {
    src?: string;
    aspectRatio?: number;
  };
};

const ArticleVideo: FunctionComponent<ArticleVideoProps> = (props) => {
  const { src, aspectRatio } = props.node || {};
  return <EmbeddedVideo src={src} aspectRatio={aspectRatio} />;
};

const articleVideoRenderer = (props: ArticleVideoProps) => {
  return <ArticleVideo {...props} />;
};

export default articleVideoRenderer;
